/**
 * Where the "That is wrong" popover goes (kanban fc6bca28): fixed-position,
 * under its trigger, anchored to the trigger's right edge when that fits on
 * screen, else hugging the left edge and shrunk to the viewport. Pure, so
 * the placement is unit-testable without layout.
 */
import type { CSSProperties } from 'react';

export const POPOVER_WIDTH = 340;
export const EDGE_GAP = 8;

export function popoverStyle(rect: { bottom: number; right: number }, viewportWidth: number): CSSProperties {
  const rightGap = Math.max(EDGE_GAP, viewportWidth - rect.right);
  const fitsRightAnchored = viewportWidth - rightGap - POPOVER_WIDTH >= EDGE_GAP;
  return fitsRightAnchored
    ? { position: 'fixed', top: rect.bottom + 6, right: rightGap, width: POPOVER_WIDTH }
    : { position: 'fixed', top: rect.bottom + 6, left: EDGE_GAP, width: Math.min(POPOVER_WIDTH, viewportWidth - 2 * EDGE_GAP) };
}
